<template>
    <right-filter-drawer
        v-model="showFilterDrawer"
        :title="title"
        :disable-apply="isFiltersEmpty || !isFormValid"
        :disable-clear="isFiltersEmpty"
        @cancel="onCancelFilters"
        @apply="onApplyFilters"
        @clear="onClearFilters"
    >
        <template v-slot:content>
            <v-form ref="form" v-model="isFormValid">
                <form-generator
                    v-model="localFilters"
                    :schema="schema"
                    value-class=""
                ></form-generator>
            </v-form>
        </template>
    </right-filter-drawer>
</template>

<script>
import FormLayout from '@/components/FormLayout/VerticalFormLayout';
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import RightFilterDrawer from '@/components/Drawers/RightFilterDrawer';
import filtersMixin from '@/mixins/filtersDrawerMixin';
import filtersSchema from './filtersSchema';
import { mapState } from 'vuex';
import { isEmpty } from '@/common/helpers';
import { sortBy } from 'lodash';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'DeviceFilters',
    components: {
        'form-generator': FormGenerator,
        'right-filter-drawer': RightFilterDrawer
    },
    mixins: [filtersMixin],
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => {}
        },
        title: {
            type: String,
            required: false,
            default: 'Device filters'
        }
    },
    computed: {
        ...mapState('tags', ['deviceTags']),
        ...mapState('devices', ['deviceStatusSummary']),
        tagsOptions() {
            return sortBy(this.deviceTags, 'name');
        },
        healthStatusOptions() {
            if (!isEmpty(this.deviceStatusSummary)) {
                return Object.keys(this.deviceStatusSummary).sort();
            }
            return [];
        },
        schema() {
            // need to populate the select items list for the filters schema
            const updatedSchema = [...filtersSchema];

            const healthField = updatedSchema.find(
                item => item.name === 'healthCheckStatus'
            );
            healthField.component.props.items = this.healthStatusOptions;

            const tagsField = updatedSchema.find(
                item => item.name === 'vmsTags.name'
            );
            tagsField.component.props.items = this.tagsOptions;

            return updatedSchema;
        }
    }
};
</script>

<style></style>
